// extracted by mini-css-extract-plugin
export default {"message":"styles-module__message__src-labstep-web-core-Form-ReactForm-Errors-Message-_kwVgn"};